/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BankAccountVerificationBucketFilter {
    COMPLETE = 'COMPLETE',
    PENDING = 'PENDING',
    DECLINED = 'DECLINED',
}
